
import { Component, Vue } from '~/utility/pu-class-decorator'

@Component
export default class DatesWizardBodyClearButton extends Vue {}
